import angular from 'angular';
import template from './toggle-sidebar-btn.html';
class Controller {
    constructor(globalUi) {
        this.globalUi = globalUi;
    }
}
const toggleSidebarBtnComponent = {
    template,
    controller: Controller,
};
export default angular
    .module('doxy.videoChat.callFrames.toggleSidebarBtn', [])
    .component('toggleSidebarBtn', toggleSidebarBtnComponent).name;
